import React from 'react';
import { Image, View } from 'react-native';
import { img_scr_phoneFrame_Ios } from '../../../../utils/ImagesManagementUtils';

//= ========================================================================

const PhoneFrame = () => {
  const myStyles = {
    container: {
      width: '100%', height: 400, position: 'absolute', zIndex: 3, alignSelf: 'center', alignItems: 'center',
    },
    img_scr_phoneFrame_IosStyle: {
      width: 200,
      height: 230,
    },
  };

  return (
    <View style={myStyles.container}>
      <Image
        fadeDuration={0}
        style={myStyles.img_scr_phoneFrame_IosStyle}
        source={img_scr_phoneFrame_Ios}
      />
    </View>
  );
};
export default PhoneFrame;
